import axios from "axios";

import buildPaginationQueryOpts from "@/shared/sort/sorts";

import { IUserPrivilege } from "@/shared/model/user-privilege.model";

const baseApiUrl = 'api/user-privileges';

export default class UserPrivilegeService {
  public find(id: number): Promise<IUserPrivilege> {
    return new Promise<IUserPrivilege>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findByIdList(ids: any): Promise<IUserPrivilege[]> {
    // get request
    return new Promise<IUserPrivilege[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/find-by-id-list/${ids}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IUserPrivilege): Promise<IUserPrivilege> {
    return new Promise<IUserPrivilege>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IUserPrivilege): Promise<IUserPrivilege> {
    return new Promise<IUserPrivilege>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: IUserPrivilege): Promise<IUserPrivilege> {
    return new Promise<IUserPrivilege>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public updateRoles(userId: number, roleIds: Array<number>): Promise<IUserPrivilege> {
    return new Promise<IUserPrivilege>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}-update-role/${userId}`, roleIds)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getAllUserPrivilegesRoles(userId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}-get-roles/?userId=${userId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public findByUserId(userId: number): Promise<IUserPrivilege> {
    return new Promise<IUserPrivilege>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/user/${userId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
